export default "<ng-container *ngIf=\"date\">\r\n  <div class=\"av-table-date\">{{ label }}</div>\r\n</ng-container>";